import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { Row, Col } from 'reactstrap'
import { Config } from '../../Config'

class Pagination extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 10,
      currentValue:10,
      offset: 0,
      selected: 0,
      pageNumber:null,
      infiniteScrollPageSize: Config.infiniteScrollPageSize,
    }
    this.PageSizeChange = this.PageSizeChange.bind(this)
  }
  PageSizeChange(event) {
    //console.log(event)
    this.setState({ pageNumber: 0})
    this.setState({ selected: 0})
    if (event.target.value !== 'All'){      
      this.setState({ currentValue: parseInt(event.target.value)})
      this.setState({ value: parseInt(event.target.value) });
      this.props.PageSizeValueChange(parseInt(event.target.value));      
    }
    else{      
      this.setState({ currentValue: parseInt(event.target.value)})
      this.setState({value: parseInt(event.target.value)});
      this.props.PageSizeValueChange(parseInt(this.props.recordCount));
    }
 //   this.setState({ pageNumber: 0})
   }
  OnPageChange = (data) => {
    //console.log(data)
    this.setState({ pageNumber: data.selected})
   // if (parseInt(this.pageCount) === 1){
    //}
    //else{
      let self = this
      let selected = data.selected;
      let offset = Math.ceil(selected * self.props.perPage);
      // this.state.offset=offset;
      self.props.offset(offset);
   // }
  }

  renderPagination() {
    return(
      <Col lg={'4'} md={'4'} sm={'4'} sm={'12'} className='pageNumbers' >
          <ReactPaginate previousLabel={"<<"}
            nextLabel={">>"}
            breakLabel={<a>...</a>}
            breakClassName={"break-me"}
            pageCount={this.props.pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={this.state.pageNumber<3?this.state.pageNumber+3:6}
            onPageChange={this.OnPageChange}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            forcePage={this.props.forcePage}
            disabledClassName={"disabled"}
           />
      </Col>
    )
  }
  render() {
    return (
      <div >
         <Row className="paginationSection">
         <Col lg={this.props.recordCount > 10 ? '4' : '6'} md={this.props.recordCount > 10 ? '4' : '6'} sm={'4'} sm={'12'} className="dropDown_show">
            Show <span></span>
            <select id="per_show" onChange={this.PageSizeChange} value={this.state.value}>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value={this.state.infiniteScrollPageSize}>All</option>
            </select>
            <span></span> items per page
          </Col>
          {this.props.recordCount > 10 ? this.renderPagination() : ''}
          <Col lg={this.props.recordCount > 10 ? '4' : '6'} md={this.props.recordCount > 10 ? '4' : '6'} sm={this.props.recordCount > 10 ? '4' : '6'} sm={'12'} className='showing'>
            <span className="results">Showing {this.props.offSetValue + 1}-{(this.state.currentValue + this.props.offSetValue) > this.props.recordCount ? this.props.recordCount : (this.state.currentValue + this.props.offSetValue)} of ({this.props.recordCount}) Results</span>
          </Col>
        </Row>
      </div>
    );
  }
};


export default Pagination;




// WEBPACK FOOTER //
// ./src/components/Common/Pagination.js